export const GET_SHOPS = 'GET_SHOPS'
export const GET_SHOPS_SUCCESS = 'GET_SHOPS_SUCCESS'
export const GET_SHOPS_FAILED = 'GET_SHOPS_FAILED'

export const GET_SHOPS_BY_COMPANY_UUID = 'GET_SHOPS_BY_COMPANY_UUID'
export const GET_SHOPS_BY_COMPANY_UUID_SUCCESS = 'GET_SHOPS_BY_COMPANY_UUID_SUCCESS'
export const GET_SHOPS_BY_COMPANY_UUID_FAILED = 'GET_SHOPS_BY_COMPANY_UUID_FAILED'

export const GET_SHOP = 'GET_SHOP'
export const GET_SHOP_SUCCESS = 'GET_SHOP_SUCCESS'
export const GET_SHOP_FAILED = 'GET_SHOP_FAILED'

export const CREATE_SHOP = 'CREATE_SHOP'
export const CREATE_SHOP_SUCCESS = 'CREATE_SHOP_SUCCESS'
export const CREATE_SHOP_FAILED = 'CREATE_SHOP_FAILED'

export const UPDATE_SHOP = 'UPDATE_SHOP'
export const UPDATE_SHOP_SUCCESS = 'UPDATE_SHOP_SUCCESS'
export const UPDATE_SHOP_FAILED = 'UPDATE_SHOP_FAILED'

export const ADD_SHOP_TO_CRM = 'ADD_SHOP_TO_CRM'
export const ADD_SHOP_TO_CRM_SUCCESS = 'ADD_SHOP_TO_CRM_SUCCESS'
export const ADD_SHOP_TO_CRM_FAILED = 'ADD_SHOP_TO_CRM_FAILED'

export const GET_TENDER_ENGINE_SHOP_INFO = 'GET_TENDER_ENGINE_SHOP_INFO'
export const GET_TENDER_ENGINE_SHOP_INFO_SUCCESS = 'GET_TENDER_ENGINE_SHOP_INFO_SUCCESS'
export const GET_TENDER_ENGINE_SHOP_INFO_FAILED = 'GET_TENDER_ENGINE_SHOP_INFO_FAILED'

export const RESET_SHOP_STATE = 'RESET_SHOP_STATE'

export const GET_TAKEOVER_URL = 'GET_TAKEOVER_URL'
export const GET_TAKEOVER_URL_SUCCESS = 'GET_TAKEOVER_URL_SUCCESS'
export const GET_TAKEOVER_URL_FAILED = 'GET_TAKEOVER_URL_FAILED'

export const SEED_DATA_FOR_SHOP = 'SEED_DATA_FOR_SHOP'
export const SEED_DATA_FOR_SHOP_SUCCESS = 'SEED_DATA_FOR_SHOP_SUCCESS'
export const SEED_DATA_FOR_SHOP_FAILED = 'SEED_DATA_FOR_SHOP_FAILED'

export const GET_LOCATION = 'GET_LOCATION'
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS'
export const GET_LOCATION_FAILED = 'GET_LOCATION_FAILED'

export const GET_SHOP_LOCALISATION_SETTINGS = 'GET_SHOP_LOCALISATION_SETTINGS'
export const GET_SHOP_LOCALISATION_SETTINGS_SUCCESS = 'GET_SHOP_LOCALISATION_SETTINGS_SUCCESS'
export const GET_SHOP_LOCALISATION_SETTINGS_FAILED = 'GET_SHOP_LOCALISATION_SETTINGS_FAILED'

export const UPDATE_SHOP_LOCALISATION_SETTINGS = 'UPDATE_SHOP_LOCALISATION_SETTINGS'
export const UPDATE_SHOP_LOCALISATION_SETTINGS_SUCCESS = 'UPDATE_SHOP_LOCALISATION_SETTINGS_SUCCESS'
export const UPDATE_SHOP_LOCALISATION_SETTINGS_FAILED = 'UPDATE_SHOP_LOCALISATION_SETTINGS_FAILED'
